import React, { useState } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ThriveModal from "../../../common/ThriveModal";
import ThriveCaseSelection from "../../../common/ThriveCaseSelection";
import { handleActiveClients } from "../legacyExports";

const PRIMARY = "#9D2362";
const CARD_BORDER = "1px solid #ececf0";

/**
 * The remaining legacy Reports page: raw downloads and the older report links.
 * The Metabase buttons and question list were removed 2026-08-30 (decided:
 * Metabase entries hidden entirely; the server proxy route still exists —
 * see thrive_server/claude_doc/metabase_migration/inventory.md).
 */
const DataTab: React.FC = () => {
  const navigate = useNavigate();
  const [allCaseCardOpen, setAllCaseCardOpen] = useState(false);
  const [selectedCase, setSelectedCase] = useState<any>({
    _id: null,
    firmRecord: {},
  });

  return (
    <Box>
      <Paper
        elevation={0}
        sx={{ p: 3, borderRadius: "16px", border: CARD_BORDER }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: "#2c2c34", mb: 0.5 }}
        >
          Data &amp; raw exports
        </Typography>
        <Typography variant="body2" sx={{ color: "#8a8a93", mb: 2 }}>
          Legacy report links and CSV downloads.
        </Typography>

        <Table sx={{ maxWidth: 900 }}>
          <TableBody>
            <TableRow>
              <TableCell>
                <Button
                  onClick={() => setAllCaseCardOpen(true)}
                  sx={{ color: PRIMARY, fontWeight: 600 }}
                >
                  Active Clients Report
                </Button>
              </TableCell>
              <TableCell align="right">
                <Button onClick={handleActiveClients}>Download Raw</Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Button
                  onClick={() => navigate("/dashboard/reports/initial_contact")}
                  sx={{ color: PRIMARY, fontWeight: 600 }}
                >
                  Initial Contacts Report
                </Button>
              </TableCell>
              <TableCell align="right" />
            </TableRow>
            {/* RGA link hidden 2026-08-30 (grant program concluded);
                /dashboard/reports/rga stays reachable by URL. */}
          </TableBody>
        </Table>
      </Paper>

      <ThriveModal
        height={700}
        open={allCaseCardOpen}
        contentComponent={
          <ThriveCaseSelection
            height={500}
            cases={[]}
            reloadCases={true}
            checkedCases={[]}
            setCheckedCases={() => {}}
            selectedCase={selectedCase}
            setSelectedCase={setSelectedCase}
            enableControl={true}
            enableSelection={true}
            enableMultiSelection={false}
            setOpen={setAllCaseCardOpen}
            title={"All Cases"}
            status_default="either"
            sortby_default="recent"
            period_default="all"
            handleNext={() => {
              if (selectedCase._id) {
                window.open(`/firmReportPdf?id=${selectedCase._id}`, "_blank");
              } else {
                console.error("No case selected");
              }
            }}
          />
        }
      />
    </Box>
  );
};

export default DataTab;
